import clsx from 'clsx';
import { connect } from "react-redux";
import { makeStyles } from 'tss-react/mui';
import { getTypeColor } from "../shared-functions/notification";
import { Fonts } from "../styles/Fonts";
import { Theme247 } from '../styles/Theme247';
import { NotificationTypeUpdated, getNotificationTooltipAndColor } from "../types";
import { useEffect } from 'react';
import { Tooltip } from '@mui/material';
import { truncateWithEllipses } from '../utils/helpers';

  const TypeBadge = (props) => {

  let badgeProps = generateBadgeProps(props);

  function generateBadgeProps(props) {
    if (props?.typecode !== null) {
      let text = NotificationTypeUpdated(Number(props?.typecode), props?.notification);   
        return { status: props?.notification?.type === 6 ? ((props?.notification?.hasmaintenancetask && props?.notification?.hasmaintenancetask[0]?.maintenancetask?.hascategory) ? props?.notification?.hasmaintenancetask[0]?.maintenancetask?.hascategory[0]?.maintenancecategory?.colorcode : "#000000") :  getTypeColor(props?.typecode, 'badge') , text: text };
    } else {
      return { status: getTypeColor(undefined, 'badge'), text: 'Undefined badge typecode.' };
    }
  }



  /*
  * Styles
  */
  const useStyles = makeStyles()((theme) => ({
    badge: {
      display: 'flex',
      flexShrink: 1,
      justifyContent: 'center',
      padding: 4,
      borderColor: Theme247.palette.grayShade["300"],
      borderStyle: 'solid',
      borderWidth: 1,
      ...Fonts.RubikRegular,
      fontSize: 12,
      lineHeight: 1.4,
      borderRadius: Theme247.roundness,
      textAlignVertical: 'center',
      textAlign: 'center',
      whiteSpace: 'nowrap'
    },

    /* Badge: Status Types*/
    badgeStatusGray: {
      color: Theme247.palette.grayShade["500"],
      borderColor: Theme247.palette.grayShade["500"],
    },

    badgeStatusMidGray: {
      color: Theme247.palette.grayShade["500"],
      borderColor: Theme247.palette.grayShade["500"],
    },

    badgeStatusGreen: {
      color: Theme247.palette.success.main,
      borderColor: Theme247.palette.success.main,
    },

    badgeStatusOrange: {
      color: Theme247.palette.warning.main,
      borderColor: Theme247.palette.warning.main,
    },

    badgeStatusRed: {
      color: Theme247.palette.error.main,
      borderColor: Theme247.palette.error.main,
    },

    badgeStatusDarkMagenta: {
      color: "#8E24AA",
      borderColor: "#8E24AA",
    },

    cardBadge: {
      marginLeft: 10,
      marginTop: -4,
    },
  }));

  const { classes } = useStyles();

  let orderColor = getNotificationTooltipAndColor(props?.notification?.type)?.color;

  return (
    <div className={clsx(" typeBadge", classes.badge, classes[badgeProps?.status?.class],  props.oncard ? classes.cardBadge : '')} style={{ border : props?.notification?.type === 6 ? "1px solid "+badgeProps.status : "1px solid "+ orderColor, color: props?.notification?.type === 6 ? badgeProps.status : orderColor}}>
       <Tooltip
                title={getNotificationTooltipAndColor(props?.notification?.type)?.tooltip}
              >
                <div>{truncateWithEllipses(badgeProps.text,20)}</div>
                </Tooltip> 
    </div>
  );
};

TypeBadge.defaultProps = {
  typecode: null,
  oncard: true,
  notification: undefined
};


export default connect(({ isAuthUser, i18n }) => ({ isAuthUser, i18n }), {})(TypeBadge);
